import { z } from 'zod';

export const NameMatchSchema = z.enum(['none', 'partial', 'exact']);
export type NameMatch = z.infer<typeof NameMatchSchema>;

export const VerificationResultSchema = z.enum(['low', 'medium', 'high']);
export type VerificationResult = z.infer<typeof VerificationResultSchema>;
